/* eslint-disable import/prefer-default-export */
export const nativeAppName = "mybenefit";
export const nativeRedirectionQueryParam = "redirectNative";
export const nativeGTMKey = "GTM-TM8R4F3J";